/**
 * Inayah — Hide Size Dropdown When Color Is Sold Out (v3)
 * ────────────────────────────────────────────────────────
 * v3 changes:
 *  - Always re-evaluate on any DOM mutation in body (no early-return cache miss)
 *  - Polls every 250ms as ultimate safety net
 *  - Removes any legacy alert nodes left from v112-v114
 */
(function () {
  'use strict';

  var STATE = { data: null, colorIdx: -1, sizeIdx: -1 };

  function getProductHandleFromUrl() {
    var m = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : null;
  }

  function findSizeWrappers() {
    // Return ALL size wrappers (sticky bar may have its own copy)
    var out = [];
    var els = document.querySelectorAll('[data-product-option]');
    for (var i = 0; i < els.length; i++) {
      var v = (els[i].getAttribute('data-product-option') || '').toLowerCase();
      if (v.indexOf('size') !== -1) out.push(els[i]);
    }
    return out;
  }

  function findColorOptionIndex(productData) {
    if (!productData || !productData.options) return -1;
    for (var i = 0; i < productData.options.length; i++) {
      var n = (productData.options[i].name || productData.options[i] || '').toString().toLowerCase();
      if (n.indexOf('color') !== -1 || n.indexOf('colour') !== -1) return i;
    }
    return -1;
  }

  function findSizeOptionIndex(productData) {
    if (!productData || !productData.options) return -1;
    for (var i = 0; i < productData.options.length; i++) {
      var n = (productData.options[i].name || productData.options[i] || '').toString().toLowerCase();
      if (n.indexOf('size') !== -1) return i;
    }
    return -1;
  }

  function getSelectedColor() {
    var el = document.querySelector('.product-option-item[data-option-type="color"][data-selected="true"]');
    if (!el) return null;
    var v = el.getAttribute('data-value') || (el.textContent || '').trim();
    return v ? v.trim() : null;
  }

  function variantOptionAt(variant, idx) {
    if (!variant) return '';
    if (variant.options && variant.options[idx] != null) return variant.options[idx];
    var key = 'option' + (idx + 1);
    return variant[key] || '';
  }

  function colorHasInStockSize(productData, colorIdx, color) {
    if (!productData || !productData.variants) return true;
    if (colorIdx < 0 || !color) return true;
    var c = (color || '').toString().trim().toLowerCase();
    for (var i = 0; i < productData.variants.length; i++) {
      var v = productData.variants[i];
      var vc = (variantOptionAt(v, colorIdx) || '').toString().trim().toLowerCase();
      if (vc === c && v.available) return true;
    }
    return false;
  }

  function removeLegacyMessage() {
    var nodes = document.querySelectorAll('#inayah-size-soldout-msg, .inayah-size-soldout-msg');
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].parentNode) nodes[i].parentNode.removeChild(nodes[i]);
    }
  }

  function update() {
    if (!STATE.data) return;
    removeLegacyMessage();
    var wrappers = findSizeWrappers();
    if (!wrappers.length) return;
    var color = getSelectedColor();

    var shouldHide = false;
    if (color && STATE.colorIdx >= 0) {
      shouldHide = !colorHasInStockSize(STATE.data, STATE.colorIdx, color);
    }

    for (var i = 0; i < wrappers.length; i++) {
      if (shouldHide) {
        wrappers[i].setAttribute('data-inayah-hidden', 'true');
        wrappers[i].style.setProperty('display', 'none', 'important');
      } else if (wrappers[i].getAttribute('data-inayah-hidden') === 'true') {
        wrappers[i].removeAttribute('data-inayah-hidden');
        wrappers[i].style.display = '';
      }
    }
  }

  function init() {
    var handle = getProductHandleFromUrl();
    if (!handle) return;
    if (!document.querySelector('[data-product-option]')) return;

    fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data) return;
        STATE.data = data;
        STATE.colorIdx = findColorOptionIndex(data);
        STATE.sizeIdx = findSizeOptionIndex(data);
        if (STATE.colorIdx < 0 || STATE.sizeIdx < 0) return;

        update();
        [50, 200, 500, 1000].forEach(function (ms) { setTimeout(update, ms); });

        // Always re-evaluate on click anywhere on a color swatch
        document.addEventListener('click', function (e) {
          if (!e.target || !e.target.closest) return;
          var sw = e.target.closest('.product-option-item[data-option-type="color"], [data-option-type="color"]');
          if (!sw) return;
          [0, 50, 150, 350, 700].forEach(function (ms) { setTimeout(update, ms); });
        }, true);

        // Document mutation observer — always re-runs (no diff check)
        var pending = false;
        var observer = new MutationObserver(function () {
          if (pending) return;
          pending = true;
          requestAnimationFrame(function () {
            pending = false;
            update();
          });
        });
        observer.observe(document.body, {
          subtree: true,
          attributes: true,
          attributeFilter: ['data-selected', 'class', 'style'],
          childList: true
        });

        // Safety-net poll: 250ms forever (cheap)
        setInterval(update, 250);

        document.addEventListener('variant:change', update);
        document.addEventListener('product:variant-change', update);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
